/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rooms_Move_DownInputs */



/**
* | output |
* | --- |
* | "Move down" |
*
* @param {Rooms_Move_DownInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rooms_move_down = /** @type {((inputs?: Rooms_Move_DownInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rooms_Move_DownInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Descendre")
	if (locale === "es") return /** @type {LocalizedString} */ ("Bajar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Mover para baixo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sposta giù")
	return /** @type {LocalizedString} */ ("Move down")
});